module.exports = __webpack_public_path__ + "static/media/role3.30337c99.png";